import financeiroApi from '../financeiroApi';

const PATH = '/api/v1/backend/fiscal/origem-produto';

export default {
  getOne: (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  search: (params) => {
    return financeiroApi.get(`${PATH}/pesquisar`, { params });
  },
};
